/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Arabic (العربية)

export default {
	'Type something': 'إبدأ في الكتابة...',
	'About Jodit': 'حول جوديت',
	'Jodit Editor': 'محرر جوديت',
	"Jodit User's Guide": 'دليل مستخدم جوديت',
	'contains detailed help for using': 'يحتوي على مساعدة مفصلة للاستخدام',
	'For information about the license, please go to our website:':
		'للحصول على معلومات حول الترخيص، يرجى الذهاب لموقعنا:',
	'Buy full version': 'شراء النسخة الكاملة',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'حقوق الطبع والنشر © XDSoft.net - Chupurnov Valeriy. كل الحقوق محفوظة.',
	Anchor: 'مِرْساة',
	'Open in new tab': 'فتح في نافذة جديدة',
	'Open in fullsize': 'فتح المحرر في الحجم الكامل',
	'Clear Formatting': 'مسح التنسيق',
	'Fill color or set the text color': 'ملء اللون أو تعيين لون النص',
	Redo: 'إعادة',
	Undo: 'تراجع',
	Bold: 'عريض',
	Italic: 'مائل',
	'Insert Unordered List': 'إدراج قائمة غير مرتبة',
	'Insert Ordered List': 'إدراج قائمة مرتبة',
	'Align Center': 'محاذاة للوسط',
	'Align Justify': 'محاذاة مثبتة',
	'Align Left': 'محاذاة لليسار',
	'Align Right': 'محاذاة لليمين',
	'Insert Horizontal Line': 'إدراج خط أفقي',
	'Insert Image': 'إدراج صورة',
	'Insert file': 'ادخال الملف',
	'Insert youtube/vimeo video': 'إدراج فيديو يوتيوب/فيميو ',
	'Insert link': 'إدراج رابط',
	'Font size': 'حجم الخط',
	'Font family': 'نوع الخط',
	'Insert format block': 'إدراج كتلة تنسيق',
	Normal: 'عادي',
	'Heading 1': 'عنوان 1',
	'Heading 2': 'عنوان 2',
	'Heading 3': 'عنوان 3',
	'Heading 4': 'عنوان 4',
	Quote: 'إقتباس',
	Code: 'كود',
	Insert: 'إدراج',
	'Insert table': 'إدراج جدول',
	'Decrease Indent': 'تقليل المسافة البادئة',
	'Increase Indent': 'زيادة المسافة البادئة',
	'Select Special Character': 'تحديد أحرف خاصة',
	'Insert Special Character': 'إدراج حرف خاص',
	'Paint format': 'تنسيق الرسم',
	'Change mode': 'تغيير الوضع',
	Margins: 'هوامش',
	top: 'أعلى',
	right: 'يمين',
	bottom: 'أسفل',
	left: 'يسار',
	Styles: 'الأنماط',
	Classes: 'الطبقات',
	Align: 'محاذاة',
	Right: 'اليمين',
	Center: 'الوسط',
	Left: 'اليسار',
	'--Not Set--': '--غير مضبوط--',
	Src: 'Src',
	Title: 'العنوان',
	Alternative: 'العنوان البديل',
	Link: 'الرابط',
	'Open link in new tab': 'افتح الرابط في نافذة جديدة',
	Image: 'الصورة',
	file: 'ملف',
	Advanced: 'متقدم',
	'Image properties': 'خصائص الصورة',
	Cancel: 'إلغاء',
	Ok: 'حسنا',
	'File Browser': 'متصفح الملفات',
	'Error on load list': 'حدث خطأ في تحميل القائمة ',
	'Error on load folders': 'حدث خطأ في تحميل المجلدات',
	'Are you sure?': 'هل أنت واثق؟',
	'Enter Directory name': 'أدخل اسم المجلد',
	'Create directory': 'إنشاء مجلد',
	'type name': 'أكتب إسم',
	'Drop image': 'إسقاط صورة',
	'Drop file': 'إسقاط الملف',
	'or click': 'أو أنقر',
	'Alternative text': 'النص البديل',
	Upload: 'رفع',
	Browse: 'تصفح',
	Background: 'الخلفية',
	Text: 'نص',
	Top: 'أعلى',
	Middle: 'الوسط',
	Bottom: 'الأسفل',
	'Insert column before': 'إدراج عمود قبل',
	'Insert column after': 'إدراج عمود بعد',
	'Insert row above': 'إدراج صف أعلى',
	'Insert row below': 'إدراج صف أسفل',
	'Delete table': 'حذف الجدول',
	'Delete row': 'حذف الصف',
	'Delete column': 'حذف العمود',
	'Empty cell': 'خلية فارغة',
	'Chars: %d': '%d حرف',
	'Words: %d': '%d كلام',
	'Strike through': 'اضرب من خلال',
	Underline: 'أكد',
	superscript: 'حرف فوقي',
	subscript: 'مخطوطة',
	'Cut selection': 'قطع الاختيار',
	'Select all': 'اختر الكل',
	Break: 'استراحة',
	'Search for': 'البحث عن',
	'Replace with': 'استبدل ب',
	Replace: 'محل',
	Paste: 'معجون',
	'Choose Content to Paste': 'اختر محتوى للصق',
	source: 'مصدر',
	bold: 'بالخط العريض',
	italic: 'مائل',
	brush: 'شغل',
	link: 'صلة',
	undo: 'إلغاء',
	redo: 'كرر',
	table: 'طاولة',
	image: 'صورة',
	eraser: 'نظيف',
	paragraph: 'فقرة',
	fontsize: 'حجم الخط',
	video: 'فيديو',
	font: 'الخط',
	about: 'حول المحرر',
	print: 'طباعة',
	underline: 'أكد',
	strikethrough: 'شطب',
	indent: 'المسافة البادئة',
	outdent: 'نتوء',
	fullsize: 'ملء الشاشة',
	shrink: 'الحجم التقليدي',
	hr: 'الخط',
	ul: 'قائمة',
	ol: 'قائمة مرقمة',
	cut: 'قطع',
	selectall: 'اختر الكل',
	'Embed code': 'قانون',
	'Open link': 'فتح الرابط',
	'Edit link': 'تعديل الرابط',
	'No follow': 'سمة Nofollow',
	Unlink: 'إزالة الرابط',
	Update: 'تحديث',
	pencil: 'لتحرير',
	Eye: 'مراجعة',
	' URL': 'URL',
	Edit: 'تحرير',
	'Horizontal align': 'محاذاة أفقية',
	Filter: 'فلتر',
	'Sort by changed': 'عن طريق التغيير',
	'Sort by name': 'بالاسم',
	'Sort by size': 'حسب الحجم',
	'Add folder': 'إضافة مجلد',
	Reset: 'إعادة',
	Save: 'احتفظ',
	'Save as ...': 'حفظ باسم',
	Resize: 'تغيير الحجم',
	Crop: 'حجم القطع',
	Width: 'عرض',
	Height: 'ارتفاع',
	'Keep Aspect Ratio': 'حافظ على النسب',
	Yes: 'أن',
	No: 'لا',
	Remove: 'حذف',
	Select: 'تميز',
	'Select %s': 'تميز %s',
	'Vertical align': 'محاذاة عمودية',
	Split: 'انشق، مزق',
	Merge: 'اذهب',
	'Add column': 'أضف العمود',
	'Add row': 'اضف سطر',
	'License: %s': 'رخصة %s',
	Delete: 'حذف',
	'Split vertical': 'انقسام عمودي',
	'Split horizontal': 'تقسيم أفقي',
	Border: 'الحدود',
	'Your code is similar to HTML. Keep as HTML?':
		'يشبه الكود الخاص بك HTML. تبقي كما HTML؟',
	'Paste as HTML': 'الصق ك HTML',
	Keep: 'احتفظ',
	'Insert as Text': 'إدراج كنص',
	'Insert only Text': 'إدراج النص فقط',
	'You can only edit your own images. Download this image on the host?':
		'يمكنك فقط تحرير صورك الخاصة. تحميل هذه الصورة على المضيف؟',
	'The image has been successfully uploaded to the host!':
		'تم تحميل الصورة بنجاح على الخادم!',
	palette: 'لوحة',
	'There are no files': 'لا توجد ملفات في هذا الدليل.',
	Rename: 'إعادة تسمية',
	'Enter new name': 'أدخل اسم جديد',
	preview: 'معاينة',
	download: 'تحميل',
	'Paste from clipboard': 'لصق من الحافظة',
	"Your browser doesn't support direct access to the clipboard.":
		'متصفحك لا يدعم إمكانية الوصول المباشر إلى الحافظة.',
	'Copy selection': 'نسخ التحديد',
	copy: 'نسخ',
	'Border radius': 'دائرة نصف قطرها الحدود',
	'Show all': 'عرض كل',
	Apply: 'تطبيق',
	'Please fill out this field': 'يرجى ملء هذا المجال',
	'Please enter a web address': 'يرجى إدخال عنوان ويب',
	Default: 'الافتراضي',
	Circle: 'دائرة',
	Dot: 'نقطة',
	Quadrate: 'المربعة',
	Find: 'البحث',
	'Find Previous': 'تجد السابقة',
	'Find Next': 'تجد التالي',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'للصق المحتوى قادم من Microsoft Word/Excel الوثيقة. هل تريد أن تبقي شكل أو تنظيفه ؟ ',
	'Word Paste Detected': 'كلمة لصق الكشف عن',
	Clean: 'نظيفة',
	'Insert className': 'أدخل اسم الفصل',
	'Press Alt for custom resizing': 'اضغط البديل لتغيير حجم مخصص',
	'Line height': 'ارتفاع الخط',
	spellcheck: 'التدقيق الإملائي',
	'Speech Recognize': 'التعرف على الكلام',
	All: 'تحديد الكل'
};
